import { getModels, getModel, storeModel, deleteModel } from '@/structures/default//api/models';
import { ref } from 'vue';

export default function useModels(params) {
  const models = ref([]);
  const currentModel = ref([]);
  const page = ref(1);
  const settings = ref(params);

  const fetchModels = async (params) => {
    if (params.filter) {
      settings.value.filter = params.filter;
    }
    if (params.sort) {
      settings.value.sort = params.sort;
    }
    if (params.size) {
      settings.value.size = params.size;
    }
    models.value = await getModels(page.value, settings.value);
  };

  const fetchModel = async (id) => {
    currentModel.value = await getModel(id, settings.value.resourceType);
  };

  return {
    models,
    currentModel,
    page,
    settings,
    fetchModels,
    fetchModel,
    storeModel,
    deleteModel,
  };
}
